module.exports = __webpack_public_path__ + "img/modify_bg.6ed9b94f.png";